angular.module('resourceCenterStockModule').service('stockService', [
    'trsspliceString',
    'stockApiService',
    '$q',
    function(trsspliceString, stockApiService, $q) {
        return {
            getSourceName: getSourceName, // 获取来源名称
            findReprintCounts: findReprintCounts, // 获取文章转载量
            queryItemBYGUID: queryItemBYGUID, // 根据guid获取在WCM内的取签见撤重的二进制数
            initOperFlag: initOperFlag, // 初始化取签见撤重
        };

        /**
         * [getSourceName 根据不同渠道返回不同的来源名称]
         *
         * @param   {[type]}  fcode  [fcode description]
         *
         * @return  {[type]}         [return description]
         */
        function getSourceName(fcode) {
            let sourceNameMap = {
                szb: '报纸',
                wz: '网站',
                app: '客户端',
                wx: '公众号',
                website: '媒体',
                wb: '微博',
                baijiahao: '百家号',
                qie: '企鹅号',
                toutiao: '头条号',
                douyin: '抖音号',
                tv: '电视台',
                broadcast: '广播电台',
            };
            let name = sourceNameMap[fcode] || '媒体';
            return name;
        }

        /**
         * [findReprintCounts 获取文章转载量]
         *
         * @param   {[type]}  listData  [listData description]
         *
         * @return  {[type]}            [return description]
         */
        function findReprintCounts(listData) {
            let defer = $q.defer();
            var tags = trsspliceString.spliceString(listData, 'MD5TAG', ',');
            if (tags) {
                var params = stockApiService.getReprintCountsParams();
                params.tags = tags;
                stockApiService.getReprintCounts(params).then(function(data) {
                    for (var i = 0; i < listData.length; i++) {
                        listData[i].REPRINTS_COUNT = data.content[0][listData[i].MD5TAG];
                    }
                    defer.resolve(listData);
                });
            }
            return defer.promise;
        }

        /**
         * [queryItemBYGUID 根据guid获取在WCM内的取签见撤重的二进制数]
         *
         * @param   {[type]}  guid       [guid 文章guid]
         * @param   {[type]}  operFlags  [operFlags 文章取签见撤重标识]
         *
         * @return  {[type]}             [return description]
         */
        function queryItemBYGUID(guid, operFlags) {
            for (var i in operFlags) {
                if (guid === operFlags[i].GUID) {
                    return operFlags[i];
                }
            }
        }

        /**
         * [initOperFlag 初始化取签见撤重]
         *
         * @param   {[type]}  fcode     [fcode description]
         * @param   {[type]}  listData  [listData description]
         *
         * @return  {[type]}            [return description]
         */
        function initOperFlag(fcode, listData) {
            let defer = $q.defer();
            let basicParams = {
                channelName: 'jtcpg',
                typeName: 'jt_lyzh',
                nodeId: fcode,
            };
            var docIds = trsspliceString.spliceString(listData, 'ZB_GUID', ',');
            if (docIds) {
                var params = stockApiService.getListFlagParams();
                params.guids = docIds;
                params = angular.extend(params, basicParams);
                stockApiService.getListFlag(params).then(function(data){
                    let operFlags = [];
                    var temp = data;
                    for (var i in temp) {
                        if (angular.isDefined(data[i]) && data[i].OPERFLAG.indexOf('1') > -1) {
                            operFlags = operFlags.concat(data[i]);
                        }
                    }
                    defer.resolve(operFlags);
                });
            }
            return defer.promise;
        }
    },
]);
